import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";

import { RiHotelBedFill } from "react-icons/ri";
import TypeSurgeryModal from "../../Modal/SurgeryModal/TypeSurgeryModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getTypeSurgeryAction,
  updateTypeSurgeryAction,
} from "../../Actions/SurgeryAction/SurgeryAction";
import { RxUpdate } from "react-icons/rx";
import { CgClose } from "react-icons/cg";
import LoadingPage from "../Loading/LoadingPage";

const TypeSurgery = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [debounceValue, setDebounceValue] = useState();
  const [inputValue, setInputValue] = useState({
    enName: "",
    krdName: "",
  });
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(debounceValue)
    if (debounceValue !== null) {
      dispatch(getTypeSurgeryAction(debounceValue));
    }
  }, [debounceValue]);
  const getTypeSurgery = useSelector((state) => state.getTypeSurgery);
  const { typeSurgeries, loading } = getTypeSurgery;
  const [indexx, setIndexx] = useState(null);
  const [state, setState] = useState({
    organ: "",
    Type: "",
    id: "",
  });

  const [errors, setErrors] = useState({});
  const validate = () => {
    const errors = {};
    if (!state.organ.trim()) {
      errors.organ = "Organ is required";
    }
    

    return errors;
  };

  const handleUpdate = (e) => {

    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    console.log("sdfjsd")
    dispatch(updateTypeSurgeryAction(state.id, state.organ, state.Type));
    setErrors({});
    setIndexx(null);
  };
  const handleClose = () => {
    setIndexx(null);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue({ ...inputValue });
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);
  return (
    <>
      <div className="parent">
        <div className="flex justify-between gap-2 px-2 items-center">
          <div className="flex gap-1 items-center font-bold text-teal-600">
            <RiHotelBedFill />
            <p>Organ</p>
          </div>
          <div className="mt-1">
            <button
              onClick={() => setIsOpenModal(true)}
              className="btn-info flex gap-2 items-center"
            >
              <p> Add Organ</p>
              <FaPlus />
            </button>
          </div>
        </div>
        <div className="w-full px-2 flex gap-2 mt-2 m-auto">
          <input
            type="text"
            placeholder="Search By Organ"
            className="w-full input"
            value={inputValue.enName}
            onChange={(e) => {
              setInputValue({ ...inputValue, enName: e.target.value });
            }}
          />
    
        </div>
        {loading ? (
          <LoadingPage />
        ) : (
          <div className="parent-table">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Organ</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {typeSurgeries?.map((type, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {index == indexx ? (
                        <td>
                          <input
                            type="text"
                            className="input w-full"
                            placeholder="Organ"
                            value={state.organ}
                            onChange={(e) => {
                              setState({
                                ...state,
                                organ: e.target.value,
                              });
                            }}
                          />
                          {errors.organ && (
                            <p style={{ color: "red" }}>{errors.organ}</p>
                          )}
                        </td>
                      ) : (
                        <td>{type.name}</td>
                      )}
             
                      <td>
                        {index == indexx ? (
                          <div className="flex gap-2 items-center">
                            <button
                              onClick={handleUpdate}
                              className="btn-primary flex gap-2 items-center"
                            >
                              Update <RxUpdate />
                            </button>
                            <button
                              onClick={handleClose}
                              className="btn-danger flex gap-2 items-center"
                            >
                              Delete <CgClose />
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={(e) => {
                              
                              setIndexx(index);
                              setState({
                                ...state,
                                id: type.id,
                                organ: type.name,
                   
                              });
                            }}
                            className="btn-primary flex gap-2 items-center"
                          >
                            Update <RxUpdate />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {isOpenModal && (
          <TypeSurgeryModal closeModal={() => setIsOpenModal(false)} />
        )}
        <div className="pb-10"></div>
      </div>
    </>
  );
};

export default TypeSurgery;
